function PaginationFooter({
  currentPage,
  endItem,
  isNextDisabled,
  isPreviousDisabled,
  onNext,
  onPrevious,
  startItem,
  totalItems,
  totalPages,
}) {
  return (
    <div className="flex flex-col items-center gap-1.5 border-t border-[var(--theme-border-soft)] bg-white px-4 py-3 text-[0.88rem] text-[var(--theme-text-subtle)] sm:flex-row sm:items-center sm:justify-between sm:gap-3">
      <div className="order-1 flex items-center justify-center gap-3 sm:order-2">
        <button
          className="rounded-xl border border-[var(--theme-border-soft)] bg-white px-4 py-2 text-[0.86rem] font-medium text-[var(--theme-text-muted)] transition hover:bg-[var(--theme-surface-soft)] disabled:cursor-not-allowed disabled:text-[#c5bbb0] disabled:hover:bg-white"
          type="button"
          onClick={onPrevious}
          disabled={isPreviousDisabled}
        >
          Prev
        </button>
        <span className="whitespace-nowrap text-center text-[var(--theme-text-strong)]">
          Page {currentPage} of {totalPages}
        </span>
        <button
          className="rounded-xl border border-[var(--theme-border-soft)] bg-white px-4 py-2 text-[0.86rem] font-medium text-[var(--theme-text)] transition hover:bg-[var(--theme-surface-soft)] disabled:cursor-not-allowed disabled:text-[#c5bbb0] disabled:hover:bg-white"
          type="button"
          onClick={onNext}
          disabled={isNextDisabled}
        >
          Next
        </button>
      </div>
      <span className="order-2 text-center sm:order-1">
        Showing {startItem}-{endItem} of {totalItems}
      </span>
    </div>
  );
}

export default PaginationFooter;
